import styled, { css } from 'styled-components';
import { BannerHeading } from '../../global/typography';

export const StyledContainer = styled.div<{ $flex: 'row' | 'column' }>`
    display: flex;
    width: 100%;
    gap: 30px;
    margin-top: 25px;

    ${props =>
        props.$flex === 'row' &&
        css`
            flex-direction: row;

            @media (max-width: 979px) {
                justify-content: center;
            }

            @media (max-width: 600px) {
                flex-direction: column;
            }
        `}

    ${props =>
        props.$flex === 'column' &&
        css`
            flex-direction: column;
        `}

  @media (max-width: 979px) {
        gap: 15px;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    gap: 30px;
    flex-wrap: wrap;
`;

export const MainHeroHeading = styled(BannerHeading)`
    color: white;
    margin-bottom: 15px;

    @media (max-width: 979px) {
        text-align: center;
        margin-bottom: 0px;
    }
`;
